/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { useEffect, useRef, useState } from "react";
import {
  SelectChangeEvent,
  TextField,
  Tooltip,
  Chip as MuiChip,
} from "@mui/material";
import { TreeSelect } from "primereact/treeselect";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TextInputField from "../../utils/text-input-field/TextInputField";
import AcceptTerms from "../../utils/accept-terms/AcceptTerms";
import "./CreateUser1.scss";
import ConfirmModal from "../../utils/modals/confirm-modal/ConfirmModal";
import InfoModal from "../../utils/modals/info-modal/InfoModal";
import Loader from "../Loader/Loader";
import UploadProfilePic from "../../utils/upload-profile-pic/UploadProfilePic";
import { IErrorProps } from "../../models";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { getOrganizationByTenantID } from "../../store/Organisation/organisation-actions";
import OrganizationDTO from "../../models/apiModels/OrganizationDTO";
import {
  getCountryCodes,
  getIdentityProviderbyTenantId,
} from "../../store/Tenant/tenant-actions";
import IdentityProviderDTO from "../../models/apiModels/IdentityProviderDTO";
import OrganizationHDTOKey from "../../models/apiModels/OrganizationHDTOKey";
import {
  createUser,
  getUserRolesbyOrg,
  uploadUserLogoDetails,
} from "../../store/User/user-actions";
import TreeTableOrganizationData from "../../models/apiModels/TreeTableOrganizationData";
import GetOrgbyKey from "../../utils/methods/GetOrgbyKey";
import getSelectedKeys from "../../utils/methods/getSelectedKey";
import getOrganizationKeyByOrgId from "../../utils/methods/getOrganizationKeyByOrgId";
import BreadCrumbsComponent from "../SharedComponents/BreadCrumbs/BreadCrumbsComponent";
import Title from "../SharedComponents/Title/Title";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  ChipRemove,
  ControlError,
  Input,
  Label,
  Select,
  SelectOption,
} from "@forge/common";
import { Dropdown } from "../../utils/dropdown/dropdown";
import { UUID } from "../../models/apiModels/Organization";
import { setErrorPopupsusingErrorCode } from "../TenantUser/setErrorPopupsusingErrorCode";
import updateErrorList from "../../utils/methods/updateErrorList";
import { serverErrorClose } from "../SharedComponents/serverErrorClose";
import ErrorHandlingComponent from "../SharedComponents/ErrorHandlingComponent";
import { getOrganizationNameById } from "../../utils/methods/getOrganizationNameById";
import GetTokenValues from "../../utils/methods/GetTokenValues";
import DefaultProfileImgDark from "../../images/DefaultProfileImgDark.png";
import DefaultProfileImg from "../../images/addLogo.png";
import useLocalStorageChange from "../../hooks/useLocalStorageChange";
import { localeKeyMap } from "../../localization/keys";
import { useTranslation } from "@scuf/localization";
import sortCountryCodesByName from "../../utils/methods/sortCountryCodesByName";
import DropdownDTO from "../../models/componentModels/DropdownDTO";
import { ConfigurationVariables } from "../../config";

interface TreeNode {
  key: string;
  label: string;
  data: string;
  parentId: string;
  version: number;
  children: TreeNode[];
}

const TENANT_CRUMB_ID = "tenant";
const HOME_CRUMB_ID = "";
const TENANT_DETAILS_CRUMB_ID = "tenantdetails";
const ORGANISATION_CRUMB_ID = "Organisation";
const CREATE_USER_CRUMB_ID = "CreateUser";

function CreateUserPage1() {
  const [t] = useTranslation();
  const [theme, setCurrentTheme] = useState(
    localStorage.getItem("currentTheme") || "light"
  );
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [roleOptions, setRoleOptions] = useState([]);
  const [identityProviderOptions, setidentityProviderOptions] = useState<
    Array<IdentityProviderDTO>
  >([]);
  const [countryCodeOptions, setcountryCodeOptions] = useState<
    Array<DropdownDTO>
  >([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [emailId, setEmailId] = useState("");
  const [roleId, setRoleIds] = useState<string[]>([]);
  const [identityProvider, setIdentityProvider] = useState<string>("");
  const [userProfilePic, setUserProfilePic] = useState<any>();
  const [isFirstNameValid, setIsFirstNameValid] = useState<boolean>(true);
  const [islastNameValid, setIslastNameValid] = useState<boolean>(true);
  const [isFirstNameEmpty, setIsFirstNameEmpty] = useState<boolean>(false);
  const [isLastNameEmpty, setIsLastNameEmpty] = useState<boolean>(false);
  const [isEmailIdEmpty, setIsEmailIdEmpty] = useState<boolean>(false);
  const [isphoneValid, setisphoneValid] = useState<boolean>(true);
  const [isEmailValid, setIsEmailValid] = useState<boolean>(true);
  const [isRoleIdEmpty, setIsRoleIdEmpty] = useState<boolean>(false);
  const [isOrgIdEmpty, setIsOrgIdEmpty] = useState<boolean>(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState<boolean>(false);
  const [isFormFilled, setIsFormFilled] = useState<boolean>(false);
  const [isCountryCodeEmpty, setCountryCodeEmpty] = useState<boolean>(false);
  const [isIdentityProviderEmpty, setisIdentityProviderEmpty] =
    useState<boolean>(false);
  const [helpderTextIdentityProvider, sethelpderTextIdentityProvider] =
    useState<string>("");
  const [postOrganizationData, setpostOrganizationData] = useState<UUID[]>(
    location?.state?.userDetailsToEdit?.UserInfo?.organization
      ? [location?.state?.userDetailsToEdit?.UserInfo?.organization].flatMap(
          (x) => x
        )
      : []
  );
  const [chipValues, setChipValues] = useState<
    { chipValue: string; tooltipValue: string; key: string }[]
  >([]);

  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);

  const [saveEmailforConflict, setSaveEmailforConflict] = useState<
    string | null
  >(null);
  const [isSSOEnabled, setIsSSOEnabled] = useState(true);

  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const firstNameRegex = /^[a-zA-Z]+(\s[a-zA-Z]+)*$/;
  const lastNameRegex = /^[a-zA-Z]+(\s[a-zA-Z]+)*$/;
  const phoneNumberRegex = /^\d{7,14}$/;
  const [countryCodeValue, setCountryCode] = useState<string | null>(null);
  const [checkedOrgNodes, setCheckedOrgNodes] = useState<string[]>([]);

  const userPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );
  const existingUsers = useSelector((state: RootState) => state.user.users);

  useLocalStorageChange("currentTheme", (updatedTheme) => {
    if (updatedTheme) {
      setCurrentTheme(updatedTheme);
    }
  });

  const emailChangeHandeller = (value: string) => {
    setEmailId(value);
    if (value !== "") {
      setIsEmailIdEmpty(false);
    }

    const emailAlreadyExists = existingUsers.some(
      (user: any) => user.emailId?.toLowerCase() === value.toLowerCase()
    );

    if (emailAlreadyExists) {
      setSaveEmailforConflict(value);
      setIsEmailValid(false);
    } else {
      setSaveEmailforConflict(null);
      emailRegex.test(value) ? setIsEmailValid(true) : setIsEmailValid(false);
    }
  };

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  const [selectedOrgsObj, setSelectedOrgsObj] = useState<any>({});

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);

  //////////////Error Handling////////////////////////

  // Customize the rendering of each node
  // istanbul ignore next
  // Style based on node label
  const customNodeTemplate = (node: any) => {
    //CID 3263533
    const label = node.label ?? "";
    const orgData = GetOrgbyKey("0", treeTableOrganization);
    const rootLabel = orgData?.data?.name ?? "";

    const isLabel123 = label === rootLabel;
    const selectedNodesviaKey: string[] = Object.keys(selectedNodeKey ?? {});
    const containsZero = selectedNodesviaKey.includes("0");
    let backgroundColor = "";
    if (selectedNodesviaKey.length == 0) {
      backgroundColor = isLabel123 ? "#F7F7F7" : "inherit";
    } else if (containsZero) {
      backgroundColor = isLabel123 ? "#F7F7F7" : "#85848470";
    } else {
      backgroundColor = isLabel123 ? "#85848470" : "inherit";
    }

    return (
      //CID 3263548
      <div
        style={{
          backgroundColor: backgroundColor,
          height: "100%", // Simplified as the condition was redundant
          width: "100%", // Simplified as the condition was redundant
        }}
      >
        {label}
      </div>
    );
  };
  const [stateForDropDownCountry, setStateForDropDownCountry] = useState(1);

  const initialOrgArray: UUID[] =
    location?.state?.userDetailsToEdit?.UserInfo?.organization ?? [];

  const hierarchicalOrganization = useSelector(
    (state: RootState) => state.organisation.treeTableOrganization
  );

  // Country code change
  // istanbul ignore next
  // sets the country code in the state
  const countryCodeChangeHandler = (event: any) => {
    setCountryCode(event?.target?.value);
    if (event?.target?.value == null || event?.target?.value == "") {
      setCountryCodeEmpty(true);
    } else {
      setCountryCodeEmpty(false);
    }
  };

  useEffect(() => {
    setStateForDropDownCountry(stateForDropDownCountry + 1);
  }, [countryCodeOptions]);

  // istanbul ignore next
  useEffect(() => {
    if (hierarchicalOrganization?.length === 0) return;
    const initialOrgKeys = initialOrgArray
      ?.map((x) => getOrganizationKeyByOrgId(x, hierarchicalOrganization))
      .map((x) => x?.key ?? "");
    let expandedKeys: any = {};
    const getExpandedKeysInFormatFromKeys: any = () => {
      //const convertedObject = {};

      const outputObject = Object.fromEntries(
        initialOrgKeys
          ?.filter((x) => x !== "")
          .map((element) => [element, true])
      );
      for (const [key, value] of Object.entries(outputObject)) {
        expandedKeys[key] = value;
      }
      return expandedKeys;
    };
    let expandedKeys1: any = getExpandedKeysInFormatFromKeys();
    let selectedKeys: string[] = Object.keys(expandedKeys1);

    if (
      expandedKeys1 !== undefined &&
      Object.keys(expandedKeys1).length !== 0
    ) {
      // selectedKeys.includes("0") && setCheckedOrgNodes(expandedKeys1);

      setSelectedNodeKey(expandedKeys1);
      setCheckedOrgNodes(selectedKeys);
      selectedNodeKeyRef.current = Object.keys(expandedKeys1);
    }

    if (initialOrgArray.length == 0) {
      // dispatch(getUserRolesbyOrg({ orgId: dataArray[0] }));
    } else if (initialOrgArray.length == 1) {
      setIsLoading(true);
      dispatch(
        getUserRolesbyOrg({
          orgId: initialOrgArray[0],
          tenantId: location?.state?.forgetenantID,
        })
      )
        .unwrap()
        .then((response: any) => {
          setRoleOptions(
            response?.data?.map((obj: any) => {
              return {
                label: obj?.name ?? "",
                value: obj?.roleId ?? "",
                ...obj,
              };
            })
          );
        })
        .catch((error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    } else {
    }
  }, [hierarchicalOrganization]);

  const [selectedNodeKey, setSelectedNodeKey] = useState<any>({});

  const hierarchicalOrganizationwKey: OrganizationHDTOKey[] = useSelector(
    (state: RootState) => state.organisation.hierarchicalOrganizationwKey
  );
  const organizationOrigionaldata: OrganizationDTO[] = useSelector(
    (state: RootState) => state.organisation.availableOrganization
  );

  const tenantDetails = useSelector(
    (state: RootState) => state.cart.tenantDeatailsByTenantId
  );

  const treeTableOrganization: TreeTableOrganizationData[] = useSelector(
    (state: RootState) => state.organisation.treeTableOrganization
  );

  const orgDataforHoneywellAdmin = useRef<string[]>([]);

  useEffect(() => {
    if (userPermissions.can_create_tenant && treeTableOrganization.length > 0) {
      setSelectedNodeKey({ "0": true });
      setCheckedOrgNodes(["0"]);
      setIsOrgIdEmpty(false);
      selectedNodeKeyRef.current = ["0"];
      setIsLoading(true);

      const organizationId = GetOrgbyKey("0", treeTableOrganization)?.data
        ?.organizationId;
      orgDataforHoneywellAdmin.current = [organizationId];

      // setpostOrganizationData([organizationId]);
      dispatch(
        getUserRolesbyOrg({
          orgId: organizationId,
          tenantId: location?.state?.forgetenantID,
        })
      )
        .unwrap()
        .then((response: any) => {
          setRoleOptions(
            response?.data?.map((obj: any) => {
              return {
                label: obj?.name ?? "",
                value: obj?.roleId ?? "",
                ...obj,
              };
            })
          );

          setRoleIds([response?.data[0]?.roleId]);
          roleId.length !== 0 && setIsRoleIdEmpty(false);
        })
        .catch((error: any) => {})
        .finally(() => setIsLoading(false));
    }
  }, [treeTableOrganization]);

  const [crumbs, setCrumbs] = useState([
    {
      id: TENANT_CRUMB_ID,
      label: t(localeKeyMap.home),
    },
  ]);
  const isOrgPage = location?.pathname?.includes("organization") ? true : false;

  useEffect(() => {
    if (isOrgPage) {
      var OrganisationName = getOrganizationNameById(
        location?.state?.userDetailsToEdit?.UserInfo?.organization,
        organizationOrigionaldata
      );

      setCrumbs([
        {
          id: ORGANISATION_CRUMB_ID,
          label: t(localeKeyMap.organization),
        },
        {
          id: location?.state?.userDetailsToEdit?.UserInfo?.organization,
          label: OrganisationName ?? t(localeKeyMap.organization),
        },
        {
          id: CREATE_USER_CRUMB_ID,
          label: t(localeKeyMap.createUser),
        },
      ]);
    } else {
      setCrumbs([
        {
          id: HOME_CRUMB_ID,
          label: t(localeKeyMap.home),
        },
        {
          id: TENANT_DETAILS_CRUMB_ID,
          label: tenantDetails?.tenantName || `${location?.state?.forgetenantID}`,
        },
        {
          id: CREATE_USER_CRUMB_ID,
          label: t(localeKeyMap.createUser),
        },
      ]);
    }
  }, [location, tenantDetails]);
  // get hierarchial keys
  // istanbul ignore next
  // Get Label names
  function getLabelNamesForHierarchyKey(
    tree: TreeNode[],
    key: string
  ): string[] {
    const labelNames: string[] = [];

    function findNodeByKey(currentNode: TreeNode | null, currentKey: string) {
      if (currentNode && currentNode.key === currentKey) {
        labelNames.push(currentNode.label);
        const parent = tree.find((node) => node.key === currentNode.parentId);
        if (parent) {
          findNodeByKey(parent, parent.key);
        }
      } else if (currentNode && currentNode.children) {
        currentNode.children.forEach((child) =>
          findNodeByKey(child, currentKey)
        );
      }
    }

    tree.forEach((node) => findNodeByKey(node, key));

    return labelNames.reverse();
  }

  function extractKeyValues(key: string): string[] {
    const keyParts = key?.split("-");
    return keyParts.map((_, index) => keyParts.slice(0, index + 1).join("-"));
  }

  /** Effect to set errro dialog or error toastbar state to open */
  // istanbul ignore next

  useEffect(() => {
    const value = selectedNodeKey ?? [];
    const keys: string[] = Object.keys(value);
    const values = keys.map((x) => extractKeyValues(x));

    const labelNames = values?.map((y) =>
      y?.map((x) => {
        let y = getLabelNamesForHierarchyKey(
          hierarchicalOrganizationwKey,
          x as unknown as string
        );

        if (y.length > 0)
          return {
            labelName: y[0],
            key: x,
          };
      })
    );
    setChipValues((prev) => []);
    let newChipValues: {
      chipValue: string;
      tooltipValue: string;
      key: string;
    }[] = [];

    ///
    const y = labelNames?.flatMap((x) => {
      return [
        ...newChipValues,
        {
          chipValue: x[x.length - 1]?.labelName ?? "",
          tooltipValue: x.flatMap((y) => y?.labelName).join("-") ?? "",
          key: x[x.length - 1]?.key ?? "",
        },
      ];
    });
    //});
    setChipValues([...y]);
    ///
    // labelNames?.forEach((x) => {
    //   setChipValues((prev) => [
    //     {
    //       chipValue: x[x.length - 1],
    //       tooltipValue: x.join("-"),
    //     },
    //     ...chipValues,
    //   ]);
    // });
  }, [selectedNodeKey]);

  useEffect(() => {
    setIsLoading(true);
    const tenantInfoToBePassed = {
      tenantID: location?.state?.forgetenantID,
      userPermissions: userPermissions,
    };
    dispatch(getOrganizationByTenantID(tenantInfoToBePassed))
      .unwrap()
      .then(() => {})
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => setIsLoading(false));

    setIsLoading(true);
    dispatch(getIdentityProviderbyTenantId(location?.state?.forgetenantID))
      .unwrap()
      .then((response) => {
        setidentityProviderOptions(response?.customers);
        return response;
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });

    setIsLoading(true);
    dispatch(getCountryCodes())
      .unwrap()
      .then((response) => {
        const sortedCountryCodes = sortCountryCodesByName(response || []);
        const defaultCountry = sortedCountryCodes.find(
          (value: any) =>
            value?.name === ConfigurationVariables.Tenant_Settings_Default_Country
        );
        const countrycodeselected: DropdownDTO[] = sortedCountryCodes?.map(
          (value: any) => {
            return {
              value: value?.code,
              label: value?.name + " (" + value?.code + ")",
              selected: value?.code === defaultCountry?.code,
            };
          }
        );

        if (defaultCountry?.code) {
          setCountryCode(defaultCountry.code);
          setCountryCodeEmpty(false);
        }

        setcountryCodeOptions(countrycodeselected);
        return response;
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });

    setIsRoleIdEmpty(false);
  }, []);

  const cancelBtnHandler = () => {
    setConfirmModal(false);
    navigate(-1);
  };

  // Handle Ip chnage handler
  // istanbul ignore next
  // Its from dropdown select
  const handleChangeIP = (event: SelectChangeEvent) => {
    setIdentityProvider(event.target.value);
    if (event.target.value == "") {
      setisIdentityProviderEmpty(true);
      sethelpderTextIdentityProvider(t(localeKeyMap.selectIdentityProvider));
    } else {
      setisIdentityProviderEmpty(false);
      sethelpderTextIdentityProvider("");
    }
  };
  const handleChangePhone = (event: any) => {
    if (event.target.value.length >= 14) {
      event.target.value = event.target.value.slice(0, 14);
    }
    setPhoneNo(event.target.value);
    phoneNumberRegex.test(event.target.value)
      ? setisphoneValid(true)
      : setisphoneValid(false);
  };

  /**
   * Checks if the first name, last name, email and roled id entered
   * @returns boolean - returns fasle if any field is missing
   */
  let hasAllFieldsInput = () => {
    if (
      firstName &&
      lastName &&
      emailId &&
      roleId?.length &&
      countryCodeValue &&
      isphoneValid &&
      (isSSOEnabled ? identityProvider : true)
    ) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * Checks if the first name, last, email id is valid or not
   * @returns boolean - returns false if any field is invalid.
   */
  const isInputValid = () => {
    if (isFirstNameValid && islastNameValid && isEmailValid && isphoneValid) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * To display helper text
   * Setting true  in state if any field is empty
   */
  const checkFieldEmpty = () => {
    !firstName && setIsFirstNameEmpty(true);
    !lastName && setIsLastNameEmpty(true);
    !emailId && setIsEmailIdEmpty(true);
    !roleId && setIsRoleIdEmpty(true);
    !selectedNodeKey && setIsOrgIdEmpty(true);
    !phoneNo && setisphoneValid(false);
    !countryCodeValue && setCountryCodeEmpty(true);
    roleId?.length === 0 && setIsRoleIdEmpty(true);
    selectedNodeKeyRef.current?.length === 0 && setIsOrgIdEmpty(true);
    !identityProvider && setisIdentityProviderEmpty(true);
  };

  const checkFieldEmptyForIP = () => {
    if (identityProvider === "") {
      sethelpderTextIdentityProvider(t(localeKeyMap.selectIdentityProvider));
      setisIdentityProviderEmpty(true);
    }
  };
  /**
   * @summery
   * input fields validation: empty field check
   * email basic validation
   * opens confirm modal if all mandatory fields entered
   */
  const createBtnHandler = () => {
    checkFieldEmpty();
    // If SSO Is enabled , then only check for IP field value during validation of parameters
    if (isSSOEnabled) {
      checkFieldEmptyForIP();
    }

    if (hasAllFieldsInput() && !isTermsAccepted) {
      setIsFormFilled(true);
      setIsTermsAccepted(false);
    }
    if (!emailRegex.test(emailId) || saveEmailforConflict === emailId) {
      setIsEmailValid(false);
    } else {
      setIsEmailValid(true);
    }

    // checking if all mandatory fields are filled and open confirm modal
    if (hasAllFieldsInput() && isInputValid() && isTermsAccepted) {
      setConfirmModal(true);
    }
  };

  /**
   *
   * Saving user in database on click confirm create btn
   */
  const tokenValues = GetTokenValues();
  let accessTokenPayload =
    tokenValues !== undefined
      ? tokenValues.accessTokenPayload
      : {
          sub: "",
          ext: {
            customer: "",
            tenant_id: "",
          },
        };
  const tokenInfo = {
    customer: accessTokenPayload?.ext?.customer,
    tenant: accessTokenPayload?.ext?.tenant_id,
    userId: accessTokenPayload?.sub,
  };
  const confirmCreateHandler = () => {
    setConfirmModal(false);
    setOpenToastError(false);

    let reqBody = {
      firstName: firstName,
      lastName: lastName,
      emailId: emailId,
      roleId: roleId,
      organizationId: userPermissions.can_create_tenant
        ? orgDataforHoneywellAdmin.current
        : postOrganizationData,
      // phoneNumber: countryCodeValue?.code + "." + phoneNo,
      phoneNumber: countryCodeValue + "." + phoneNo,
      sso_enabled: isSSOEnabled,
      //Send Identity provider selected if SSO_Enabled=true
      //Send Identity provider as customerId from token
      customerId: isSSOEnabled ? identityProvider : tokenInfo.customer,
      tenantid: tokenInfo.tenant,
    };
    /**Creating new user in data base */
    setIsLoading(true);
    dispatch(createUser(reqBody))
      .unwrap()
      .then((response) => {
        setIsLoading(false);
        /** Upload User Profile Pic to database*/

        /**Saving profile pic only if the user uploads  */
        if (userProfilePic) {
          setIsLoading(true);
          const postData = {
            userId: response?.userId,
            logo: userProfilePic,
            customerId: location?.state?.forgetenantID,
          };
          dispatch(uploadUserLogoDetails(postData))
            .then((response) => {
              setSuccessModal(true);
            })
            .catch((error) => {
              setErrorListGlobal((prevState) =>
                updateErrorList(error, [...prevState])
              );
            })
            .finally(() => {
              setIsLoading(false);
            });
        } else {
          setIsLoading(false);
          setSuccessModal(true);
        }
      })
      .catch((error) => {
        setIsLoading(false);

        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  //for Selecting IP

  const getEmailHelperText = () => {
    let helperText = "";
    if (isEmailIdEmpty) {
      helperText = t(localeKeyMap.emailHelperTextEmpty);
    }
    if (!isEmailValid && !isEmailIdEmpty) {
      helperText = t(localeKeyMap.emailHelperTextInvalid);
    }
    if (saveEmailforConflict === emailId) {
      helperText = t(localeKeyMap.emailHelperTextConflict);
    }
    return helperText;
  };

  const getPhoneNoHelperText = () => {
    var helperTextPhone = t(localeKeyMap.phoneNumberHelperText);

    var helperTextCountryCode = t(localeKeyMap.selectCode);

    if (isCountryCodeEmpty && !isphoneValid) {
      return helperTextCountryCode + " & " + helperTextPhone;
    } else if (!isphoneValid) {
      return helperTextPhone;
    } else if (isCountryCodeEmpty) {
      return helperTextCountryCode;
    }
  };

  const getFirstNameHelperText = () => {
    let helperText = "";
    if (isFirstNameEmpty) {
      helperText = t(localeKeyMap.firstNameHelperTextEmpty);
    }
    if (!isFirstNameEmpty && !isFirstNameValid) {
      helperText = t(localeKeyMap.firstNameHelperTextInvalid);
    }
    return helperText;
  };

  const getLastNameHelperText = () => {
    let helperText = "";
    if (isLastNameEmpty) {
      helperText = t(localeKeyMap.lastNameHelperTextEmpty);
    }
    if (!isLastNameEmpty && !islastNameValid) {
      helperText = t(localeKeyMap.lastNameHelperTextInvalid);
    }
    return helperText;
  };
  // const setHelperTextPhoneNo = () => {
  //   let helperText = "";
  //   if (isphoneEmpty) {
  //     helperText = "Please enter Phone Number ";
  //   }
  //   if (!isphoneValid) {
  //     helperText = "Phone Number can only contain numbers";
  //   }
  //   return helperText;
  // };

  /**
   *
   * @param event
   * @param values selected values - list of objects
   * @param reason
   *
   * sets the selected options in the state
   */
  // useEffect(() => {
  //   const result = checkedOrgNodes.map((key) => {
  //     const { label, data } = findLabelAndData(
  //       { children: hierarchicalOrganizationwKey } as OrganizationHDTOKey,
  //       key?.split("-")
  //     );
  //     // const x = findLabelAndData(
  //     //   { children: hierarchicalOrganizationwKey } as OrganizationHDTOKey,
  //     //   key?.split("-")
  //     // );
  //     return { key, label, data };
  //   });
  // }, [checkedOrgNodes]);
  // function findLabelAndDat1a(
  //   node: OrganizationHDTOKey,
  //   keys: string[]
  // ): { label: string; data: string } {
  //   const key = keys.shift();
  //   const childNode = node.children.find((child) => child.key === key);
  //   if (childNode) {
  //     if (keys.length === 0) {
  //       return { label: childNode.label, data: childNode.data };
  //     } else {
  //       return findLabelAndDat1a(childNode, keys);
  //     }
  //   }

  //   return { label: "", data: "" };
  // }

  const assignRolesHandler = (event: { target: { value: string } }) => {
    const selectedRole = event.target.value;
    setRoleIds([selectedRole]);
    selectedRole && setIsRoleIdEmpty(false);
  };

  // Org chip
  // istanbul ignore next
  // Close handler
  const orgChipCloseHandler = (chip: any) => {
    const orgIdToRemove = selectedOrgsObj[chip.key]?.data;
    setpostOrganizationData(
      postOrganizationData.filter((x) => x !== orgIdToRemove)
    );

    let newkeys = Object.keys(selectedNodeKey);
    newkeys = newkeys.filter((x) => x !== chip.key);
    const newSelectedKeys = getSelectedKeys(newkeys);
    setSelectedNodeKey(newSelectedKeys);

    Object.keys(newSelectedKeys).length === 0 && setCheckedOrgNodes([]);
    Object.keys(newSelectedKeys).length === 0 && setRoleIds([]);
    selectedNodeKeyRef.current = Object.keys(newSelectedKeys);
  };

  // const handleChangeTextPhone = (event: any, values: any[], reason: string) => {
  //   // const selectedRoles = values && values.map((obj) => obj.value);
  //   // setRoleIds(selectedRoles);
  //   // selectedRoles?.length > 0 && setIsRoleIdEmpty(false);
  // };

  // const findOrgbyID: any = (selectedNodes: any) => {
  //   organizationOrigionaldata.map((itemId) => {
  //     if (itemId.organizationID == selectedNodes) {
  //       return itemId.parentOrganizationID;
  //     } else {
  //       return "test";
  //     }
  //   });
  // };

  // const getParentNames = (organizationId: any) => {
  //   const organization = organizationOrigionaldata.find(
  //     (org) => org.id === organizationId
  //   );

  //   if (!organization) {
  //     return null;
  //   }

  //   const parentNames = [];
  //   let currentOrganization = organization;

  //   while (currentOrganization.parentId) {
  //     const parentOrganization = organizationOrigionaldata.find(
  //       (org) => org.id === currentOrganization.parentId
  //     );

  //     if (parentOrganization) {
  //       parentNames.unshift(parentOrganization.name);
  //       currentOrganization = parentOrganization;
  //     } else {
  //       // Break if parent organization not found
  //       break;
  //     }
  //   }

  //   return parentNames.join("-");
  // };

  // function concatParentLabels(node: TreeNode): string {
  //   if (!node.parentId) {
  //     return node.label;
  //   }

  //   const parent = hierarchicalOrganizationwKey.find(
  //     (parentNode) => parentNode.key === node.parentId
  //   );

  //   if (!parent) {
  //     return node.label; // Parent not found, use the current label
  //   }

  //   const parentLabel = concatParentLabels(parent);
  //   return `${parentLabel}-${node.label}`;
  // }

  // function addConcatenatedLabels(tree: TreeNode[]): TreeNode[] {
  //   return tree.map((node) => ({
  //     ...node,
  //     concatenatedLabels: concatParentLabels(node),
  //     children: addConcatenatedLabels(node.children),
  //   }));
  // }

  //Logic for getting parent names
  // function findNode(tree: TreeNode[], keyPath: string[]): TreeNode | undefined {
  //   let currentNode: TreeNode | undefined = undefined;

  //   for (const key of keyPath) {
  //     currentNode = (currentNode ? currentNode.children : tree).find(
  //       (node) => node.key === key
  //     );

  //     if (!currentNode) {
  //       break;
  //     }
  //   }

  //   return currentNode;
  // }

  // function getParentPath(node: TreeNode): string {
  //   const path: string[] = [];
  //   let current: TreeNode | undefined = node;

  //   while (current) {
  //     path.unshift(current.label);
  //     current = findNode(hierarchicalOrganizationwKey, [current.parentId]);
  //   }

  //   return path.join("-");
  // }

  // function getOutputForTrueKeys(tree: TreeNode[], inputList: any): void {
  //   for (const [key, value] of Object.entries(inputList)) {
  //     if (value) {
  //       const keyPath = key?.split("-");
  //       const currentNode = findNode(tree, keyPath);

  //       if (currentNode) {
  //         const parentPath = getParentPath(currentNode);
  //       }
  //     }
  //   }
  // }

  // For the Organisation parent node disabled
  const selectedNodeKeyRef = useRef<string[]>([]);

  const BackNavigate = () => {
    navigate(-1);
  };

  /**
   * Handles breadcrumb click.
   * Navigates to tenant, organization, or org-user-list page
   * depending on which crumb was clicked.
   */
  const handleCrumbClick = (crumb: { id: string; href?: string }) => {
    if (crumb.id === CREATE_USER_CRUMB_ID) {
      // Current page's own crumb - no navigation
      return;
    }
    if (crumb.id === ORGANISATION_CRUMB_ID) {
      navigate("/organization");
    } else if (crumb.id === TENANT_CRUMB_ID || crumb.id === HOME_CRUMB_ID || crumb.id === TENANT_DETAILS_CRUMB_ID) {
      navigate("/tenant/user");
    } else {
      navigate("/organization-user-list");
    }
  };

  const orgFiledOnClick = (e: any) => {
    // This div is visible only furing selection
    // istanbul ignore next
    // Get value from document using query
    setTimeout(() => {
      const parentNodeClass = document.querySelector("ul.p-tree-container");
      const getParentNodeClass = document.querySelector(
        "ul.p-tree-container > li > div.p-highlight"
      );
      const getParentUlClass = document.querySelector("ul.p-tree-container");
      
      getParentUlClass?.classList.add("custom_p_tree_container");
      if (
        getParentNodeClass === null &&
        !selectedNodeKeyRef.current?.includes("0") &&
        selectedNodeKeyRef.current?.length !== 0
      ) {
        parentNodeClass?.classList.add("parent_node_disabled");
      } else {
        parentNodeClass?.classList.remove("parent_node_disabled");
      }
    }, 200);
  };

  // Org on chnage handler
  // istanbul ignore next
  const orgFiledOnChange = (e: any) => {
    if (e == null) {
      // Handle the case where e is null or undefined
      setChipValues([]);
      setSelectedNodeKey(undefined); // Adjust based on expected behavior
      selectedNodeKeyRef.current = [];
      setRoleIds([]);
      return;
    }
    const value = e.value ?? [];
    const resultinggg: string[] = Object.keys(value);
    const emptyObject = e?.value ?? {};
    const isEmpty: boolean = Object.keys(emptyObject).length === 0;
    const has1Value: boolean = Object.keys(emptyObject).length === 1;
    const containsZero: boolean = resultinggg.includes("0");
    if (isEmpty) {
      setChipValues([]);
      setSelectedNodeKey(e.value);
      selectedNodeKeyRef.current = Object.keys(value);
      setRoleIds([]);
    } else if (has1Value && containsZero) {
      setChipValues([]);
      setSelectedNodeKey(e.value);
      selectedNodeKeyRef.current = Object.keys(value);
    } else if (!containsZero) {
      // setChipValues([]);
      setSelectedNodeKey(e.value);
      selectedNodeKeyRef.current = Object.keys(value);
    } else {
    }
    // const result: any = Object.entries(value)
    //   .filter(([key, val]) => val === true)
    //   .map(([key]) => key);

    // const resulttest = [];
    var data: any = e?.value ?? [];
    for (const key in data) {
      if (data[key].checked) {
        resultinggg.push(key);
      }
    }

    setCheckedOrgNodes(resultinggg);

    function findLabelAndDataTest(
      node: OrganizationHDTOKey,
      key: string
    ): { label: string; data: string } | null {
      if (node.key === key) {
        return { label: node.label, data: node.data };
      }

      for (const child of node.children || []) {
        const result = findLabelAndDataTest(child, key);
        if (result) {
          return result;
        }
      }

      return null;
    }

    const resultDict: Record<string, { label: string; data: string }> = {};

    resultinggg.forEach((key) => {
      hierarchicalOrganizationwKey.some((item) => {
        const result = findLabelAndDataTest(item, key);
        if (result) {
          resultDict[key] = result;
          return true;
        }
        return false;
      });
    });

    setSelectedOrgsObj(resultDict);

    // Convert the resultDict to an array
    const resultArray = Object.entries(resultDict).map(([key, value]) => ({
      key,
      ...value,
    }));
    const dataArray: string[] = resultArray.map((item) => {
      return item.data.toString();
    });

    setpostOrganizationData(dataArray);
    if (dataArray.length == 0) {
      // dispatch(getUserRolesbyOrg({ orgId: dataArray[0] }));
    } else if (dataArray.length == 1) {
      setIsLoading(true);
      dispatch(
        getUserRolesbyOrg({
          orgId: dataArray[0],
          tenantId: location?.state?.forgetenantID,
        })
      )
        .unwrap()
        .then((response: any) => {
          setRoleOptions(
            response?.data?.map((obj: any) => {
              return {
                label: obj?.name ?? "",
                value: obj?.roleId ?? "",
                ...obj,
              };
            })
          );
        })
        .catch((error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    } else {
      // dispatch(getUserRolesbyOrg({ orgId: dataArray[0] }));
    }

    // if (resultinggg.includes("0")) {
    //   setRoleOptions(
    //     mockdataRolesAPICopiedData?.map((obj: any) => {
    //       return {
    //         label: obj?.name ?? "",
    //         value: obj?.roleId ?? "",
    //         ...obj,
    //       };
    //     })
    //   );
    // } else {
    //   setRoleOptions(
    //     mockdataRolesCustom?.map((obj: any) => {
    //       return {
    //         label: obj?.name ?? "",
    //         value: obj?.roleId ?? "",
    //         ...obj,
    //       };
    //     })
    //   );
    // }
    const getValue: any = e.value;
    if (Object.keys(getValue).length === 0) {
      setIsOrgIdEmpty(true);
    } else {
      setIsOrgIdEmpty(false);
    }
    // For the organisation parent node disabled
    const parentNodeClass = document.querySelector("ul.p-tree-container");
    if (
      !selectedNodeKeyRef.current?.includes("0") &&
      !isEmpty &&
      selectedNodeKeyRef.current?.length !== 0
    ) {
      parentNodeClass?.classList.add("parent_node_disabled");
    } else {
      parentNodeClass?.classList.remove("parent_node_disabled");
    }
  };

  return (
    <>
      {" "}
      <BreadCrumbsComponent
        crumbs={crumbs}
        backbutton={true}
        backButtonHandler={BackNavigate}
        onCrumbClick={handleCrumbClick}
      />
      <Title
        title={t(localeKeyMap.addUser)}
        className="p-t15 p-b15"
        buttonRequired={false}
      />
      <Card className="create_user p-b15">
        <React.Fragment key=".0">
          <CardHeader
            title={t(localeKeyMap.userProfile)}
            className="sub-header p-20"
          />
          <CardContent className="d-flex main_form_wrap p-20">
            {/* <div className="form_logo_wrap text-center"> */}
            <UploadProfilePic
              labelText={t(localeKeyMap.addPhoto)}
              profilePic={
                theme === "dark" ? DefaultProfileImgDark : DefaultProfileImg
              }
              onImageUpload={(image) => {
                setUserProfilePic(image);
              }}
            />

            <div className="form_box">
              <h4>{t(localeKeyMap.profileInformation)}</h4>

              <div className="sso-checkbox-wrapper">
                <Checkbox
                  key={`checkbox-isSSOEnabled-${isSSOEnabled}`}
                  data-testid="checkboxisSSOEnabled"
                  id="checkboxisSSOEnabled"
                  name="checkboxisSSOEnabled"
                  onChange={(ev: any) => {
                    setIsSSOEnabled(ev.target.checked);
                  }}
                  checked={isSSOEnabled}
                >
                  {t(localeKeyMap.enableSSO)}
                </Checkbox>
              </div>

              <div className="form_row">
                <div className="form_col">
                  <TextInputField
                    fieldLabel={t(localeKeyMap.firstName)}
                    id="FirstName"
                    type="text"
                    required={true}
                    placeholder={t(localeKeyMap.enter)}
                    onChange={(value) => {
                      setFirstName(value);
                      setIsFirstNameEmpty(false);
                      firstNameRegex.test(value)
                        ? setIsFirstNameValid(true)
                        : setIsFirstNameValid(false);
                    }}
                    error={isFirstNameEmpty || !isFirstNameValid}
                    helperText={getFirstNameHelperText()}
                    dataTestId="firstName"
                  />
                </div>

                <div className="form_col">
                  <TextInputField
                    fieldLabel={t(localeKeyMap.lastName)}
                    id="LastName"
                    type="text"
                    styleName="text-input-field"
                    dataTestId="lastName"
                    required={true}
                    placeholder={t(localeKeyMap.enter)}
                    onChange={(value) => {
                      setLastName(value);
                      setIsLastNameEmpty(false);
                      lastNameRegex.test(value)
                        ? setIslastNameValid(true)
                        : setIslastNameValid(false);
                    }}
                    error={isLastNameEmpty || !islastNameValid}
                    helperText={getLastNameHelperText()}
                  />
                </div>

                <div className="form_col">
                  <TextInputField
                    fieldLabel={t(localeKeyMap.emailId)}
                    id="EmailID"
                    type="text"
                    required={true}
                    styleName="text-input-field"
                    placeholder={t(localeKeyMap.emailPlaceholder)}
                    onChange={(value) => {
                      emailChangeHandeller(value);
                    }}
                    error={isEmailIdEmpty || !isEmailValid}
                    helperText={getEmailHelperText()}
                    dataTestId="emailId"
                  />
                </div>
                <div className="form_col">
                  <Label required={true} className="text-input-label">
                    {t(localeKeyMap.phoneNumber)}
                  </Label>
                  {/* istanbul ignore next */}
                  <div className="phone_number_col">
                    <Dropdown
                      key={countryCodeOptions?.length}
                      onClick={function (): void {}}
                      defaultValue={countryCodeValue ?? ""}
                      items={countryCodeOptions}
                      className="phoneNumber_dropdown"
                      onSelect={countryCodeChangeHandler}
                      useCheckIcon={true}
                      placeholder={t(localeKeyMap.selectCode)}
                      placeholderSearch={t(localeKeyMap.search)}
                      selectedLabel={t(localeKeyMap.selected)}
                      size="regular"
                      error={isCountryCodeEmpty}
                      variant="defaultSelect"
                      name="s"
                      selectLabel={["dew", "sjd"]}
                      showIcon={false}
                      enableSearch={true}
                    />

                    <Input
                      id="phoneNo"
                      className="phone_number_textField"
                      value={phoneNo}
                      type="string"
                      placeholder={t(localeKeyMap.enterPhoneNumber)}
                      onChange={handleChangePhone}
                      error={!isphoneValid}
                    />
                  </div>

                  {(isCountryCodeEmpty || !isphoneValid) && (
                    <ControlError className="control-error">
                      {getPhoneNoHelperText()}
                    </ControlError>
                  )}
                </div>
                <div className="form_col">
                  <Label required={true} className="text-input-label">
                    {t(localeKeyMap.assignOrganization)}
                  </Label>
                  {/* istanbul ignore next */}
                  <TreeSelect
                    disabled={userPermissions.can_create_tenant}
                    value={selectedNodeKey}
                    // className="text-input-field"
                    className={
                      isOrgIdEmpty
                        ? "dropdown_tree error-border-tree"
                        : "dropdown_tree "
                    }
                    filter
                    required
                    // filterMode="lenient"
                    nodeTemplate={customNodeTemplate}
                    onChange={(e) => orgFiledOnChange(e)}
                    onClick={(e) => orgFiledOnClick(e)}
                    options={hierarchicalOrganizationwKey}
                    metaKeySelection={false}
                    selectionMode="multiple"
                    placeholder={t(localeKeyMap.selectOrganizations)}
                    data-testid="SelectParentOrganisation"
                    style={{
                      width: "100%",
                    }}
                  ></TreeSelect>
                  {isOrgIdEmpty && (
                    <ControlError className="control-error">
                      {t(localeKeyMap.pleaseAssignOrganization)}
                    </ControlError>
                  )}
                  <div className="form_col d-flex org-chip">
                    <div>
                      {chipValues.map(
                        (chip, index) =>
                          index < 2 && (
                            <Chip
                              className="mb-2 theme-chip"
                              onClick={function noRefCheck() {}}
                              disabled={userPermissions.can_create_tenant}
                            >
                              {chip.chipValue}
                              <ChipRemove
                                onClick={() => orgChipCloseHandler(chip)}
                                className="theme-chip-remove"
                              >
                                {t(localeKeyMap.removeChip)}
                              </ChipRemove>
                            </Chip>
                          )
                      )}
                    </div>
                    {chipValues.length > 2 && (
                      <>
                        <Chip className="mb-2 dot-item theme-chip">..</Chip>
                        <Tooltip
                          title={chipValues
                            .slice(2)
                            .map((chip, index) => chip.tooltipValue)
                            .join(", ")}
                          placement="top"
                          arrow={true}
                        >
                          <div>
                            <Chip
                              className="mb-2 theme-chip"
                              disabled={userPermissions.can_create_tenant}
                            >
                              {`+${(chipValues.length - 2).toString()}`}
                            </Chip>
                          </div>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </div>

                <div className="form_col">
                  {/* Assign Role option ---------------------------------- */}
                  <Label required>{t(localeKeyMap.assignRole)}</Label>
                  {checkedOrgNodes.length === 0 ? (
                    <div>
                      <Select
                        key={`disabled-${roleId[0]}`}
                        error={isRoleIdEmpty}
                        id="assign-role-select-disabled"
                        placeholder={t(localeKeyMap.selectAnOption)}
                        defaultValue={roleId[0]}
                        data-testid="SelectRole"
                        disabled
                        className="select-role"
                      >
                        {roleOptions.map((option: any) => {
                          return (
                            <SelectOption
                              key={option.value}
                              label={option.label}
                              value={option.value}
                            />
                          );
                        })}
                      </Select>
                    </div>
                  ) : (
                    <Select
                      key={`role-select-${roleId[0]}`}
                      error={isRoleIdEmpty}
                      disabled={userPermissions.can_create_tenant}
                      id="assign-role-select"
                      defaultValue={roleId[0]}
                      data-testid="SelectRole"
                      onChange={(event: any) => {
                        assignRolesHandler(event);
                      }}
                      placeholder={t(localeKeyMap.selectAnOption)}
                      className="select-role"
                    >
                      {roleOptions.map((option: any) => {
                        return (
                          <SelectOption
                            key={option.value}
                            label={option.label}
                            value={option.value}
                          />
                        );
                      })}
                    </Select>
                  )}
                  {isRoleIdEmpty && (
                    <ControlError className="control-error">
                      {t(localeKeyMap.pleaseSelectRoles)}
                    </ControlError>
                  )}
                </div>

                {/* istanbul ignore next */}
                {
                  <div className="form_col">
                    <Label requiredText="*">
                      {" "}
                      {t(localeKeyMap.identityProvider)} *{" "}
                    </Label>

                    <Dropdown
                      isDisabled={!isSSOEnabled}
                      key={identityProviderOptions?.length}
                      onClick={function (): void {}}
                      items={identityProviderOptions?.map(
                        (value: IdentityProviderDTO) => {
                          return {
                            value: value.customerId,
                            label: value.name + " (" + value.customerId + ")",
                          };
                        }
                      )}
                      error={
                        isIdentityProviderEmpty && isSSOEnabled ? true : false
                      }
                      className="select-ip"
                      onSelect={handleChangeIP}
                      useCheckIcon={true}
                      placeholder={t(localeKeyMap.selectIP)}
                      placeholderSearch={t(localeKeyMap.search)}
                      selectedLabel={t(localeKeyMap.selected)}
                      size="regular"
                      variant="defaultSelect"
                      name="IP"
                      showIcon={false}
                      enableSearch={false}
                    />
                    {isSSOEnabled && isIdentityProviderEmpty && (
                      <ControlError className="control-error">
                        {t(localeKeyMap.pleaseAssignIdentityProvider)}
                      </ControlError>
                    )}
                  </div>
                }
                {/* Org VAlues */}
                {/* istanbul ignore next */}

                {/* Org VAlues */}
              </div>
              <AcceptTerms
                isFormFilled={isFormFilled}
                isTermsAccepted={isTermsAccepted}
                onTermsAccept={(event) => {
                  setIsTermsAccepted(event?.target.checked);
                }}
              />
            </div>
          </CardContent>
        </React.Fragment>
      </Card>
      {/* </Card> */}
      {/* Footer starts */}
      <Card className="footer">
        <Button
          size="regular"
          variant="quiet-primary"
          className="cursor-pointer"
          onClick={() => cancelBtnHandler()}
          data-testid="cancelBtn"
        >
          {t(localeKeyMap.cancel)}
        </Button>

        <Button
          size="regular"
          variant="primary"
          className="cursor-pointer"
          onClick={createBtnHandler}
          data-testid="createBtn"
        >
          {t(localeKeyMap.create)}
        </Button>
      </Card>
      {/* Footer end */}
      <ConfirmModal
        dialogTitle={t(localeKeyMap.createUser)}
        dialogContentText={t(localeKeyMap.confirmCreateUser)}
        onConfirmClick={confirmCreateHandler}
        onCancelClick={() => setConfirmModal(false)}
        onCloseClick={() => setConfirmModal(false)}
        open={confirmModal}
      />
      <InfoModal
        dialogTitle={t(localeKeyMap.creationSuccess)}
        dialogContentText={t(localeKeyMap.userAccountCreated)}
        onOkClick={() => {
          setSuccessModal(false);
          // Navigate back with query parameters for user creation polling
          const basePath = isOrgPage ? "/organization-user-list" : "/tenant/user";
          navigate(`${basePath}?userCreated=true&userEmail=${encodeURIComponent(emailId)}`);
        }}
        open={successModal}
      />
      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />
      {isLoading && <Loader />}
    </>
  );
}
export default CreateUserPage1;
